import { all } from "redux-saga/effects";
import loaderSaga from "./loader/loaderSaga";
import forgetPasswordSaga from "./forget-password/forgetPasswordSaga";
import tabSaga from "./tabs/tagSaga";
// import userSearchSaga from "./user-search/userSearchSaga";

export default function* rootSaga() {
  yield all([
    loaderSaga(),
    forgetPasswordSaga(),
    tabSaga()
    // userSearchSaga()
  ]);
}
